import NotFoundPage from 'common/components/NotFoundPage';
import React from 'react';

export default function NotFoundContainer() {
    return <NotFoundPage />;
}
